// for development:
export const BASE_URL = "https://icsanv2.vatebra.org/api";
export const File_URL = "https://icsanv2.vatebra.org/";

// for Production:
//  export const BASE_URL = "https://icsanv2api.vatebra.org/api";
//  export const File_URL = "https://icsanv2api.vatebra.org/";

